import React from 'react';

const testIds = {
    PLAY_ICON: 'PLAY_ICON'
};

const PlayButtonIcon = (props: any) => (
    <svg
        data-test-id={testIds.PLAY_ICON}
        {...props}
        width="20"
        height="16.5"
        viewBox="0 0 20 16.5"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path fill="#F9FAFA" d="M3.53 0.69v16.33l15.88-8.17-15.88-8.17z" />
    </svg>
);

export {PlayButtonIcon};
